<div class="root">
  <div class="container">
    <h1 class="title">{{ 'skyproRoutingPage.forbidden' | transloco | skyUiTypograf }}</h1>
    <p class="description" [innerHtml]="text$ | async | skyUiTypograf"></p>
    <a href="/student-cabinet">
      <ds-button type="primary-blue" size="m">
        {{ 'skyproRoutingPage.goToMain' | transloco | skyUiTypograf }}
      </ds-button>
    </a>
  </div>
</div>
